<template>
  <div class="content-builder">
    <div class="form-group">
      <label class="control-label">Summary Text</label>
      <QuillEditor v-model:content="content.text" :contentType="'html'" :modules="editorModules" :toolbar="toolbarOpts"
                   theme="snow"/>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col">
          <label class="control-label">Outcomes</label>
        </div>
        <div class="col">
          <div class="form-group">
            <input id="custom-score-toggle" v-model="content.customScoreEnabled" type="checkbox">
            <label for="custom-score-toggle">Enable Custom Score Ranges</label>
          </div>
        </div>
      </div>
      <div class="content-list">
        <div v-for="(outcome, key) in content.outcomes" v-cloak :key="key" class="card content-list-item">
          <div class="card-body">
            <div class="form-group">
              <div class="row">
                <div class="col-md-9">
                  <p class="font-weight-bold">Grade: {{ key }}</p>
                  <label class="control-label" for="feedback">Outcome Text</label>
                  <textarea v-model="content.outcomes[key]" class="form-control" rows="5"></textarea>
                </div>
                <div class="col-md-3">
                  <p class="font-weight-bold">Custom % Range</p>
                  <div class="form-group">
                    <label for="">Max</label>
                    <input v-model.number="content.outcomeScores[key].max"
                           :class="isValid(key, 'max')? '' : 'is-invalid'" :disabled="!scoresEnabled || (key == 'A')"
                           class="form-control"
                           min="0" step="1"
                           type="number">
                  </div>
                  <div class="form-group">
                    <label for="">Min</label>
                    <input v-model.number="content.outcomeScores[key].min"
                           :class="isValid(key, 'min')? '' : 'is-invalid'" :disabled="!scoresEnabled || (key == 'F')"
                           class="form-control"
                           min="0" step="1"
                           type="number">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-4">
        <label class="control-label" for="input-text-color">Text Color</label>
        <input id="input-text-color" v-model="content.textColor" class="form-control" placeholder="#304d93"
               type="text">
      </div>
      <div class="mb-4">
        <label class="control-label" for="input-metric-bkg-color">Metric Background Color</label>
        <input id="input-metric-bkg-color" v-model="content.metricBkgColor" class="form-control" placeholder="#304d93"
               type="text">
      </div>
      <div class="mb-4">
        <label class="control-label" for="input-metric-item-bkg-color">Metric Item Background Color</label>
        <input id="input-metric-item-bkg-color" v-model="content.metricItemBkgColor" class="form-control"
               placeholder="#304d93"
               type="text">
      </div>
      <div class="mb-4">
        <label class="control-label" for="input-metric-item-active-bkg-color">Metric Item Active Background
          Color</label>
        <input id="input-metric-item-active-bkg-color" v-model="content.metricItemActiveBkgColor" class="form-control"
               placeholder="#304d93"
               type="text">
      </div>
      <div class="mb-4">
        <label class="control-label" for="input-border-color">Border Color</label>
        <input id="input-border-color" v-model="content.borderColor" class="form-control" placeholder="#304d93"
               type="text">
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import layoutMixin from '../../mixins/layout'
import {EDITOR_CONFIG_FULL, EDITOR_CONFIG_BUTTONS_FULL} from '../../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

const DEFAULT_OUTCOMES = {
  A: '',
  B: '',
  C: '',
  D: '',
  F: ''
}

const DEFAULT_OUTCOME_SCORES = {
  A: {min: 90, max: 100},
  B: {min: 80, max: 89},
  C: {min: 70, max: 79},
  D: {min: 60, max: 69},
  F: {min: 0, max: 59}
}

export default {
  components: {
    QuillEditor
  },
  props: ['error'],
  mixins: [layoutMixin],
  data() {
    const content = _.cloneDeep(this.source)

    content.customScoreEnabled = _.get(content, 'customScoreEnabled', false)
    content.outcomes = _.assign({}, DEFAULT_OUTCOMES, content.outcomes)
    content.outcomeScores = _.assign({}, DEFAULT_OUTCOME_SCORES, content.outcomeScores)
    content.borderColor = _.get(content, 'borderColor', '#dca63a')
    content.metricBkgColor = _.get(content, 'metricBkgColor', '#FFFFFF')
    content.metricItemBkgColor = _.get(content, 'metricItemBkgColor', '#304d93')
    content.metricItemActiveBkgColor = _.get(content, 'metricItemActiveBkgColor', '#dca63a')
    content.textColor = _.get(content, 'textColor', '#304d93')

    return {
      content: content,
      toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL
    }
  },
  computed: {
    scoresEnabled() {
      return this.content.customScoreEnabled
    },
  },
  methods: {
    isValid(key, minMax) {
      try {
        if (this.error.errorFields[key].some((val) => val == minMax)) {
          return false
        } else {
          return true
        }
      } catch (e) {
        return true
      }
    },
    setContent() {
      console.log('Summary::setContent')
    },
    getValue() {
      return this.content
    },
    remove(item, index) {
      this.content.outcomes.splice(index, 1)
    },
    addOutcome() {
      this.content.outcomes.unshift({
        meters: defaultMeters()
      })
    }
  }
}
</script>
